import React from 'react';
import { Clock } from 'lucide-react';
import { format } from 'date-fns';

interface SubscriptionStatusProps {
  isActive: boolean;
  expiresAt: string | null;
}

export default function SubscriptionStatus({ isActive, expiresAt }: SubscriptionStatusProps) {
  if (!isActive || !expiresAt) return null;

  return (
    <div className="flex items-center space-x-2 text-sm text-gray-600">
      <Clock className="h-4 w-4" />
      <span>
        Subscription {isActive ? 'active' : 'expires'} until{' '}
        {format(new Date(expiresAt), 'MMMM d, yyyy')}
      </span>
    </div>
  );
}